
import { defineComponent, onMounted } from "vue";
import TrainerWithInstitute from "@/views/Pending/list/TrainerWithInstitute.vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";

export default defineComponent({
  name: "dashboard",
  components: {
    TrainerWithInstitute,
  },
  data() {
    return {
      data: "",
    };
  },
  setup() {
    onMounted(() => {
      setCurrentPageTitle("Dashboard");
    });
  },
});
